(function () {
  'use strict';

  if (window.__budgiverseCollectionPageLoaded) return;
  window.__budgiverseCollectionPageLoaded = true;

  const surfaces = document.querySelectorAll('.budgiverse-collection-hero, .budgiverse-collection-grid-shell');
  if (!surfaces.length) return;

  const cleanupMap = new WeakMap();
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsCardHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  surfaces.forEach(initSurface);

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event?.target;
    if (!section) return;

    const surface = section.matches?.('.budgiverse-collection-hero, .budgiverse-collection-grid-shell')
      ? section
      : section.querySelector?.('.budgiverse-collection-hero, .budgiverse-collection-grid-shell');

    if (!surface) return;

    const cleanup = cleanupMap.get(surface);
    if (typeof cleanup === 'function') {
      cleanup();
      cleanupMap.delete(surface);
    }
  });

  function initSurface(surface) {
    const cleanups = [];

    cleanups.push(initReveal(surface));

    if (!prefersReducedMotion && supportsCardHover) {
      cleanups.push(initPointerCards(surface));
    }

    cleanupMap.set(surface, () => {
      cleanups.forEach((cleanup) => {
        if (typeof cleanup === 'function') cleanup();
      });
    });
  }

  function initReveal(surface) {
    const revealNodes = surface.querySelectorAll('.budgi-reveal');
    if (!revealNodes.length) return () => {};

    const timeoutIds = [];
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const delay = parseInt(entry.target.dataset.revealDelay || '0', 10);
        const timeoutId = window.setTimeout(() => {
          entry.target.classList.add('is-visible');
        }, delay);

        timeoutIds.push(timeoutId);
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -40px 0px'
    });

    revealNodes.forEach((node) => observer.observe(node));

    return function cleanupReveal() {
      observer.disconnect();
      timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
    };
  }

  function initPointerCards(surface) {
    const cards = surface.querySelectorAll('[data-budgi-collection-card]');
    if (!cards.length) return () => {};

    const listeners = [];

    cards.forEach((card) => {
      const handleMove = (event) => {
        const rect = card.getBoundingClientRect();
        const relativeX = (event.clientX - rect.left) / rect.width;
        const relativeY = (event.clientY - rect.top) / rect.height;
        const tiltY = (relativeX - 0.5) * 5;
        const tiltX = (0.5 - relativeY) * 4;

        card.style.setProperty('--pointer-x', `${(relativeX * 100).toFixed(2)}%`);
        card.style.setProperty('--pointer-y', `${(relativeY * 100).toFixed(2)}%`);
        card.style.setProperty('--tilt-x', `${tiltX.toFixed(2)}deg`);
        card.style.setProperty('--tilt-y', `${tiltY.toFixed(2)}deg`);
      };

      const handleLeave = () => {
        card.style.setProperty('--pointer-x', '50%');
        card.style.setProperty('--pointer-y', '50%');
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      };

      card.addEventListener('pointermove', handleMove, { passive: true });
      card.addEventListener('pointerleave', handleLeave, { passive: true });
      card.addEventListener('pointercancel', handleLeave, { passive: true });

      listeners.push(() => {
        card.removeEventListener('pointermove', handleMove);
        card.removeEventListener('pointerleave', handleLeave);
        card.removeEventListener('pointercancel', handleLeave);
      });
    });

    return function cleanupPointerCards() {
      listeners.forEach((removeListener) => removeListener());
    };
  }
})();
